import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  Grid,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import useRequestIdGenerater from "customhooks";
import axios from "axios";

const PaymentInfo = ({
  values,
  handleChange,
  setFieldValue,
  selectedBatchs,
  isEdit = false,
}) => {
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();
  const requestId = useRequestIdGenerater();

  const [feeMappingList, setFeeMappingList] = useState([]);

  const handleCheckboxChangeParticipant = (event) => {
    const { name, checked } = event.target;
    setFieldValue("participantsFee", checked);
    if (checked) fetchFeeMappings();
  };

  const fetchFeeMappings = async () => {
    try {
      const response = await axios.get(
        `/v1/fee/fee-mapping?batchId=${
          selectedBatchs.length > 0 ? selectedBatchs : ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken",
            )}`,
            "Content-Type": "application/json",
            requestId: requestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
            ),
          },
        },
      );
      if (response.status === 200) {
        generateTimeStamp();
        const onlyEventFeeHead = response?.data?.data?.filter(
          (item) => item?.feeHeads?.applicableFor === "Event",
        );
        setFeeMappingList(onlyEventFeeHead);
      }
    } catch (error) {
      generateTimeStamp();
    }
  };

  useEffect(() => {
    if (isEdit) fetchFeeMappings();
    generateTimeStamp();
  }, []);

  return (
    <Grid container direction="row" alignItems="center" spacing={2}>
      {/* <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.funding}
              onChange={handleCheckboxChangeDonation}
              name="activeDonation"
            />
          }
          label="Active Donation"
        />
      </Grid> */}
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.participantsFee}
              onChange={handleCheckboxChangeParticipant}
              name="participantsFee"
            />
          }
          label="Active Participant Fee"
        />
      </Grid>
      {values?.participantsFee && (
        <Grid item md={6} xs={12}>
          {/* <TextField
            fullWidth
            label="Amount"
            name="participantFee"
            onChange={handleChange}
            value={values?.participantFee}
          /> */}
          <FormControl fullWidth>
            <InputLabel id="age-select">Select Fee</InputLabel>
            <Select
              labelId="feemapping-select"
              id="feeMappingIds"
              name="feeMappingIds"
              autoComplete="new-password"
              multiple
              onChange={(e) => {
                setFieldValue("feeMappingIds", e.target.value);
              }}
              value={values?.feeMappingIds || []}
              label="Select Fee"
              renderValue={(selected) =>
                selected
                  .map((id) => {
                    const match = feeMappingList?.find((f) => f?.id === id);
                    return match?.feeHeads?.name;
                  })
                  .join(", ")
              }
            >
              {feeMappingList?.map((data) => (
                <MenuItem key={data?.id} value={data?.id}>
                  {data?.feeHeads?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
};

export default PaymentInfo;
